module.exports = __webpack_public_path__ + "static/Vision2-1a6e8cdfbac3ffb0484ada75f4f29475.png";